module.exports = __webpack_public_path__ + "static/media/rtf.316745d2.png";